import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class MenuItemIsOpenBinding implements ICustomBinding {

    // Der von knockout-kendo beim kendoMenuItem-Binding mitgebrachte Parameter isOpen ist ein One-Way-Binding,
    // d.h. die durch das Widget selbst verursachten Wechsel des Geöffnet-Zustands werden dort nicht an das ViewModel zurückübertragen.
    // Das Two-Way-Binding wird hingegen durch dieses eigene Binding realisiert.

    public initBinding() {
        ko.bindingHandlers.menuItemIsOpen = {
            init: (element: HTMLElement, valueAccessor: () => any) => {
                ko.utils.domData.set(element, 'isOpen', false);
                let options = ko.unwrap(valueAccessor());
                let widget = ko.unwrap(options.widget);
                let state = options.state;

                widget.bind('open', (e) => {
                    if (e.item == element) {
                        ko.utils.domData.set(element, 'isOpen', true);
                        state(true);
                    }
                });

                widget.bind('close', (e) => {
                    if (e.item == element) {
                        ko.utils.domData.set(element, 'isOpen', false);
                        state(false);
                    }
                });


            },
            update: (element: HTMLElement, valueAccessor: () => any) => {
                let itemIsOpen = ko.utils.domData.get(element, 'isOpen');
                let options = ko.unwrap(valueAccessor());
                let state = ko.unwrap(options.state);
                let widget = ko.unwrap(options.widget);

                if (state != itemIsOpen) {
                    widget[state ? 'open' : 'close'](element);
                }
            }
        };
    }
}